import { isTruthy, Truthy } from '../../type-validation/generic/isTruthy';

export function assertIsTruthy<T>(value: T): asserts value is Truthy<T> {
  if (!isTruthy(value)) throw new Error(`Value is falsy`);
}
